export const getSettingsProperty = ({ settings, updateData }) => ({ key, defaultValue = null }) => {
    let value = settings.hasOwnProperty(key) ? settings[key] : defaultValue;
    if (updateData.hasOwnProperty(key)) {
        value = updateData.poolRequestAttachments;
    }
    return value;
}
